import { toast } from 'vue-sonner'
import axios from 'axios'
import { logger } from '@/utils/logger'

type ToastOptions = Parameters<typeof toast.info>[1]

export const getErrorMessage = (error: unknown, fallback = '') => {
  if (typeof error === 'string') return error
  if (error && typeof error === 'object' && 'message' in error) {
    const message = (error as { message?: unknown }).message
    if (typeof message === 'string' && message.trim()) return message
  }
  return fallback
}

export const logError = (scope: string, error: unknown, extra?: Record<string, unknown>) => {
  if (extra) {
    logger.error(scope, error, extra)
    return
  }
  logger.error(scope, error)
}

export const notifyError = ({
  scope,
  error,
  message,
  options,
}: {
  scope: string
  error: unknown
  message: string
  options?: ToastOptions
}) => {
  if (axios.isCancel(error)) return
  logError(scope, error)
  toast.error(message, options)
}

export const notifyErrorMessage = (message: string, options?: ToastOptions) => {
  toast.error(message, options)
}

export const notifySuccess = (message: string, options?: ToastOptions) => {
  toast.success(message, options)
}

export const notifyWarning = (message: string, options?: ToastOptions) => {
  toast.warning(message, options)
}

export const notifyInfo = (message: string, options?: ToastOptions) => {
  toast.info(message, options)
}

export const withErrorMessage = async <T>(
  scope: string,
  runner: () => Promise<T>,
  fallbackMessage: string,
) => {
  try {
    return await runner()
  } catch (error) {
    notifyError({ scope, error, message: fallbackMessage })
    return null
  }
}
